import { MAX_FILE_NAME_LENGTH } from './Constants'

export const getFileNameProperties = (fileName: string): { extension: string; name: string } | undefined => {
  const _fileName = fileName.split('.')

  const extension = [..._fileName].pop()

  const name = [..._fileName].splice(0, _fileName.length - 1).join('.')
  if (!extension || !name) return undefined

  return {
    extension,
    name,
  }
}

export const convertToMB = (fileSize: number) => {
  return fileSize / 1000
}

const round = (number: number, decimals: number) => {
  const factorOfTen = Math.pow(10, decimals)

  return Math.round(number * factorOfTen) / factorOfTen
}

export const convertFileSizeWithUnit = (sizeInBytes: number, decimalPlaces: number): string => {
  const sizeInMb = round(sizeInBytes / 1000000, decimalPlaces)
  if (sizeInMb <= 0) return `${round(sizeInBytes / 1000, decimalPlaces)} KB`

  return `${sizeInMb} MB`
}

export const handleFileName = (fileName: string): string => {
  const fileProperties = getFileNameProperties(fileName)
  if (!fileProperties) return ''

  const { name, extension } = fileProperties
  if (name.length <= MAX_FILE_NAME_LENGTH) return fileName

  const shortenedFileName = name.split('').splice(0, 40).join('')

  return `${shortenedFileName}...${extension}`
}
